export const BASE_URL_API = '/admin/api';
export const BASE_URL_API_USER = '/user/api';
export const BASE_URL_API_STAFF = '/staff/api';
